import { MsalProvider } from '@azure/msal-react';
import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';

import App from './App';
import './index.css';
import { createMsalInstance } from './msalConfig';
import store from './redux/store';

function RootComponent({ msalInstance }) {
  return (
    <Provider store={store}>
      <Router>
        <Suspense fallback={<div>Loading...</div>}>
          <MsalProvider instance={msalInstance}>
            <App />
          </MsalProvider>
        </Suspense>
      </Router>
    </Provider>
  );
}

const orgId = process.env.REACT_APP_MSAL_ORGID;
const authority = `https://${process.env.REACT_APP_MSAL_AUTHORITY}.b2clogin.com/${process.env.REACT_APP_MSAL_AUTHORITY}.onmicrosoft.com/${orgId}`;

const msalInstance = createMsalInstance(authority);

// ✅ Initialize MSAL before rendering
msalInstance
  .initialize()
  .then(() => {
    // Store globally so apiClient.js can access it
    window.__MSAL_INSTANCE__ = msalInstance;

    const root = ReactDOM.createRoot(document.getElementById('root'));

    // Only render once MSAL is ready
    if (window.self === window.top) {
      root.render(<RootComponent msalInstance={msalInstance} />);
    } else {
      root.render(<div>Unsecured Page</div>);
    }
  })
  .catch(error => {
    console.error('MSAL initialization failed:', error);
    const root = ReactDOM.createRoot(document.getElementById('root'));
    root.render(<div>Failed to initialize authentication</div>);
  });
